var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAaneelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".j{fill:#fff;}.k{fill:url(#h);}.l{fill:url(#i);}.m{fill:url(#f);}.n{fill:url(#g);}.o{fill:url(#e);}.p{fill:#1b75bb;}.q{fill:url(#d);}.r{fill:url(#b);}.s{fill:url(#c);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 68.2598,
    cy: 58.0259,
    fx: 68.2598,
    fy: 58.0259,
    r: 26.4341,
    gradientTransform: "translate(-16.3132 -36.0398) rotate(2.9062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#faaf40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#f05a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#dc5124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#c0441e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#b6401c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5964,
    stopColor: "#ac3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6757,
    stopColor: "#932e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7758,
    stopColor: "#6a190a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#3e0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0.9279,
    cy: 22.494,
    fx: 0.9279,
    fy: 22.494,
    r: 34.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e94d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    stopColor: "#1970b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4193,
    stopColor: "#0b4c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5033,
    stopColor: "#033658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#002e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6556,
    stopColor: "#00203a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    stopColor: "#00081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 13.1124,
    cy: 25.5958,
    fx: 13.1124,
    fy: 25.5958,
    r: 19.4235,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 37.5711,
    cy: 8.2399,
    fx: 37.5711,
    fy: 8.2399,
    r: 25.503,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 23.3295,
    cy: 8.2399,
    fx: 23.3295,
    fy: 8.2399,
    r: 25.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#40b5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#2e94d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    stopColor: "#14629d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#09456f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#023353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#002d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    stopColor: "#001934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 74.73,
    y1: 15.9275,
    x2: 77.9647,
    y2: 19.8314,
    gradientTransform: "translate(-42.2888 -5.0883) rotate(-2.3728)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 62.009,
    y1: 13.8217,
    x2: 62.9635,
    y2: 14.9737,
    gradientTransform: "translate(-42.2888 -5.0882) rotate(-2.3728)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 113.2326,
    cy: -16.6748,
    fx: 113.2326,
    fy: -16.6748,
    r: 4.1601,
    gradientTransform: "translate(82.7843 115.6739) rotate(-89.851)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#ade1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1956,
    stopColor: "#00a6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#1a6aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5372,
    stopColor: "#194f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#194680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0d2657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    stopColor: "#030a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#000025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8206,
    stopColor: "#000228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8564,
    stopColor: "#020b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8904,
    stopColor: "#051945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9231,
    stopColor: "#0a2c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#10467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9859,
    stopColor: "#1764a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m48.9621,25.5688s.5462,3.3799,3.5912,4.6435c.2153.0911-.0419-.3162.1954-.2501l1.1061-.5829,14.1266-22.5457s-1.6025,1.6239-4.3668.5019c-1.2851-.5245-2.171-1.8269-2.171-1.8269l-12.4816,20.0603Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m9.2292,21.4036l8.162-12.9659s5.456-6.6781,11.0105,1.3189c0,0-3.926-1.5817-8.4218,6.142l-7.9635,12.9589s-3.7025,5.9695-11.4772.6263c0,0,3.1811-.5841,4.8417-2.3438.7159-.7572,3.2453-4.7236,3.8484-5.7365Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m23.4589,21.436l8.1653-12.9657s5.456-6.6784,11.0112,1.3187c0,0-3.9273-1.5814-8.4197,6.1387l-7.925,12.9299s-3.7061,5.9659-11.4794.6263c0,0,3.182-.5841,4.8456-2.3438.7138-.7572,3.2038-4.6876,3.802-5.7041Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m31.6318,8.4737s3.052-.7502,5.0799,4.1245l6.7931,15.3737s1.2101,3.7811,4.9869,3.7781c2.2015,0,3.2444-.4563,5.393-2.4086,0,0-2.6107-.9646-3.5911-2.8502-.3872-.7474-1.0814-2.312-1.0814-2.312,0,0-2.6169-5.7255-3.4267-7.5139-.737-1.6233-2.019-5.0808-2.8866-6.6723-1-1.8404-3.9037-5.7341-8.2368-3.9692-1.2209.492-2.1019,1.171-3.0303,2.4499Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m17.3685,8.4737s3.0545-.7502,5.083,4.1245l6.7937,15.3737s1.208,3.7811,4.9827,3.7781c2.204,0,3.3239-.5113,5.4747-2.46,0,0-2.5077-.6367-3.4887-2.5236-.3884-.7498-1.2627-2.5872-1.2627-2.5872,0,0-2.6138-5.7255-3.4245-7.5139-.7349-1.6233-2.019-5.0808-2.8869-6.6723-.9994-1.8404-3.9055-5.7341-8.2359-3.9692-1.2202.492-2.1013,1.171-3.0352,2.4499Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m32.3092,8.1073s4.9888-6.0166,10.2323,1.4921l6.5876,14.6605s-2.6349,4.8582.16,7.1194c0,0-3.5576.5027-4.7903-2.3848,0,0-5.0417-11.161-8.3693-18.1122-1.2575-2.6279-3.0481-2.6187-3.8202-2.775Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m17.978,8.1398s4.7631-6.0952,10.1051,1.5511l.314.6624s-1.5603,11.1836-4.704,4.4685c-.6352-1.3578-1.2536-2.6667-1.8258-3.8539-1.2822-2.6774-3.1022-2.671-3.8893-2.8282Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m65.588.25c1.8333.0028,3.3153,1.4958,3.3095,3.3337-.0043,1.8325-1.4951,3.3156-3.3307,3.3086-1.8334-.0037-3.3181-1.4924-3.3123-3.3294.0065-1.8343,1.4951-3.3196,3.3334-3.3129Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m66.9743,2.329c0,.2049-.2324.3621-.5208.3621-.2878-.0037-.5202-.167-.5177-.3621,0-.1994.2315-.363.5177-.3603.2884.0028.5208.1645.5208.3603Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m66.1947,2.7531c0,.0661-.0773.1138-.1725.1138-.0936,0-.1694-.0477-.1667-.1138,0-.0658.0731-.1181.1694-.1181.0924,0,.1697.0523.1697.1181Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m80.0329,11.6117c2.5646,0,4.7493.7284,6.5539,2.1847,1.8034,1.4569,2.7055,3.2108,2.7055,5.2628v7.8949c0,.2979-.1571.5499-.4722.7566-.3143.2067-.6954.3107-1.1413.3107-.4477,0-.8324-.104-1.1545-.3107-.3232-.2067-.4847-.4587-.4847-.7566v-3.997h-8.8124c-.4468,0-.8316-.1077-1.1548-.3229-.322-.2153-.4838-.4716-.4838-.7694s.1618-.5542.4838-.7689c.3232-.2159.708-.3236,1.1548-.3236h8.8124v-1.7131c0-1.4563-.5869-2.6973-1.7621-3.723-1.1753-1.0263-2.59-1.5398-4.2447-1.5398s-3.0701.5135-4.2454,1.5398c-1.1749,1.0257-1.7627,2.2667-1.7627,3.723v7.9194c0,.2979-.1569.5542-.4715.77-.3147.2147-.6951.3223-1.142.3223-.4636,0-.8523-.1076-1.167-.3223-.3143-.2159-.4715-.4722-.4715-.77v-7.9194c0-2.052.9065-3.8059,2.7181-5.2628,1.8126-1.4563,3.9927-2.1847,6.5421-2.1847Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m91.1475,21.7162c0-1.8037.7987-3.3432,2.3957-4.6178,1.597-1.2746,3.5212-1.9119,5.772-1.9119s4.175.6373,5.772,1.9119c1.597,1.2747,2.3958,2.8141,2.3958,4.6178v5.238c0,.2979-.1615.5499-.4845.7566-.3223.2067-.707.3107-1.1547.3107-.4459,0-.8269-.104-1.1413-.3107-.315-.2067-.4722-.4587-.4722-.7566v-5.238c0-1.208-.4801-2.2392-1.4398-3.0912-.9596-.852-2.1187-1.2783-3.4753-1.2783s-2.5163.4263-3.4753,1.2783c-.9596.852-1.4404,1.8832-1.4404,3.0912,0,1.1914.4808,2.2134,1.4404,3.0655.9591.852,2.1187,1.2789,3.4753,1.2789.5621,0,1.1174-.0832,1.663-.249.2319-.0819.4716-.1235.7199-.1235.3639,0,.7241.0948,1.0801.285.3553.1902.5339.4593.5339.8074,0,.4465-.2979.7694-.8936.9682-.9926.3303-2.0276.4967-3.1034.4967-2.2508,0-4.175-.6417-5.772-1.9248-1.597-1.2826-2.3957-2.8171-2.3957-4.6043Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m109.5882,19.0103c0-4.7661,1.7872-7.1493,5.3622-7.1493,1.8037,0,3.3927,1.0416,4.7665,3.127.8936,1.374,1.6049,3.0126,2.1346,4.916.4134,1.5058.9804,2.8961,1.7009,4.1707.7193,1.274,1.3278,1.9609,1.8245,2.0599.7113,0,1.2703-.4306,1.6753-1.2905.4055-.8606.6086-2.0361.6086-3.5254v-8.416c0-.2979.1615-.5542.4838-.7691.3235-.2147.7077-.3233,1.1548-.3233.4465,0,.8275.1086,1.1419.3233.3144.2149.471.4712.471.7691v8.416c0,4.6509-1.8447,6.9757-5.5353,6.9757-1.8037,0-3.3597-1.0337-4.6674-3.1028-.8275-1.2911-1.5144-2.9212-2.0599-4.89-.4141-1.5071-1.0055-2.9004-1.7756-4.1833-.7688-1.2829-1.411-1.9734-1.9236-2.0728-.6452,0-1.1584.4504-1.5395,1.3523-.3804.9018-.5713,2.1062-.5713,3.6126v7.9439c0,.2979-.1572.5499-.4709.7566-.3144.2067-.6955.3107-1.142.3107-.463,0-.852-.104-1.1676-.3107-.3138-.2067-.471-.4587-.471-.7566v-7.9439Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m132.8925,21.7162c0-1.8037.7982-3.3432,2.3951-4.6178,1.597-1.2746,3.5218-1.9119,5.772-1.9119,1.7218,0,3.2851.3936,4.6918,1.1798,1.4074.7865,2.4001,1.8166,2.9787,3.09.0991.2324.1499.4642.1499.6954,0,.7119-.3725,1.1254-1.1175,1.2422l-8.7384,1.4386c-.1327.0171-.2642.0257-.397.0257-.381,0-.729-.0832-1.0428-.2483-.3976-.2153-.5957-.4967-.5957-.844,0-.5627.4135-.9102,1.241-1.0429l7.0503-1.1419c-.9596-1.4894-2.367-2.2343-4.2203-2.2343-1.3566,0-2.5156.4263-3.4753,1.2783-.9596.852-1.4398,1.8832-1.4398,3.0912,0,1.1914.4801,2.2134,1.4398,3.0655.9596.852,2.1187,1.2789,3.4753,1.2789,1.7376,0,3.1028-.6544,4.0955-1.9615.2985-.3969.7786-.5957,1.441-.5957.2648,0,.5125.0336.7437.0991.5957.1988.8936.5211.8936.9688,0,.1817-.0575.3469-.173.4967-.745.9927-1.7334,1.7701-2.9665,2.3321-1.233.5634-2.578.8453-4.0343.8453-2.2501,0-4.175-.6417-5.772-1.9248-1.597-1.2826-2.3951-2.8171-2.3951-4.6043Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m150.2396,21.7162c0-1.8037.7988-3.3432,2.3958-4.6178,1.597-1.2746,3.5217-1.9119,5.772-1.9119,1.7217,0,3.2851.3936,4.6924,1.1798,1.4061.7865,2.3994,1.8166,2.9786,3.09.0997.2324.1486.4642.1486.6954,0,.7119-.3725,1.1254-1.1168,1.2422l-8.7383,1.4386c-.1327.0171-.2649.0257-.3976.0257-.3804,0-.7285-.0832-1.0422-.2483-.3975-.2153-.5957-.4967-.5957-.844,0-.5627.4134-.9102,1.241-1.0429l7.0503-1.1419c-.9597-1.4894-2.367-2.2343-4.2203-2.2343-1.3566,0-2.5156.4263-3.4753,1.2783-.9596.852-1.4398,1.8832-1.4398,3.0912,0,1.1914.4801,2.2134,1.4398,3.0655.9597.852,2.1187,1.2789,3.4753,1.2789,1.7376,0,3.1034-.6544,4.0967-1.9615.2979-.3969.7774-.5957,1.4386-.5957.2654,0,.5138.0336.7462.0991.5957.1988.8936.5211.8936.9688,0,.1817-.0587.3469-.1743.4967-.7449.9927-1.7334,1.7701-2.9664,2.3321-1.2331.5634-2.578.8453-4.0343.8453-2.2502,0-4.175-.6417-5.772-1.9248-1.597-1.2826-2.3958-2.8171-2.3958-4.6043Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m168.2081,12.9026c0-.2979.1572-.5542.4722-.7691.3144-.2147.7034-.3233,1.1664-.3233.4471,0,.8275.1086,1.1419.3233.3143.2149.4722.4712.4722.7691v14.0516c0,.2979-.1578.5499-.4722.7566-.3144.2067-.6948.3107-1.1419.3107-.463,0-.852-.104-1.1664-.3107-.315-.2067-.4722-.4587-.4722-.7566v-14.0516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaneelLogo);
export default __webpack_public_path__ + "static/media/aaneel-logo.1ecf14645e6f8964ce3b2c9bf8fa6ba9.svg";
export { ForwardRef as ReactComponent };